import { ApiAuthorization } from '@paragon/contract-library';

import { UserService } from '../connections';

export async function authorizeApiAccess(email: string, token?: string) {
  return UserService.post<{ authorization: string; jwt: string }>('api/authorize', { data: { email, token } });
}

export async function getApiAuthorizations() {
  return UserService.get<ApiAuthorization[]>('api/authorizations');
}

export async function renameApiAuthorization(guid: string, name: string) {
  return UserService.patch<ApiAuthorization>(`api/authorizations/${guid}`, { data: { name } });
}

export async function revokeApiAuthorization(guid: string) {
  return UserService.patch<ApiAuthorization>(`api/authorizations/${guid}`, { data: { revoked: true } });
}
